import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { LOCALE_PREFIX } from './constants'

import './style.scss'

export default class Link extends PureComponent {
    static propTypes = {
        blockKey: PropTypes.string.isRequired,
        onClick: PropTypes.func,
    }

    static defaultProps = {
        onClick: () => {},
    }

    onClickHandler = () => {
        const { blockKey, onClick } = this.props

        onClick(blockKey)
    }

    render() {
        const { blockKey } = this.props

        return (
            <div className={'portfolio-navigation-desk-link'} onClick={this.onClickHandler}>
                <FormattedMessage id={`${LOCALE_PREFIX}.${blockKey}`} />
            </div>
        )
    }
}
